import assign from "lodash/fp/assign";
import apis from "../../core/apis.js";

class BasicPlanResource {
  constructor($resource) {
    "ngInject";

    this.$resource = $resource;
  }

  getAll(options) {
    return this.$resource(apis.basicPlan).get(options);
  }

  get(id) {
    return this.$resource(apis.basicPlan + id).get();
  }

  search(name = "", params) {
    return this.$resource(apis.basicPlan).get(assign(params, { name }));
  }

  post(item) {
    return this.$resource(apis.basicPlan).save(item);
  }

  activate(id) {
    return this.$resource(apis.basicPlan + id + "activate").save(id);
  }

  deactivate(id) {
    return this.$resource(apis.basicPlan + id + "deactivate").save(id);
  }

  update(id, item) {
    return this.$resource(apis.basicPlan + id, null, {
      update: { method: "PATCH" },
    }).update(item);
  }
}

export default BasicPlanResource;



// WEBPACK FOOTER //
// ./src/resources/basicPlan/basicPlan.resource.js